import { useTranslation } from '../i18n';

import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { homePathFor } from '../config/paths';

const NotFound = () => {
    const { t } = useTranslation();
    const { currentUser } = useAuth();

    const getHomeLink = () => {
        if (!currentUser) return '/login';
        return homePathFor(currentUser);
    };

    return (
        <Result
            status="404"
            title="404"
            subTitle={t('Sorry, the page you requested does not exist.')}
            extra={
                <Link to={getHomeLink()}>
                    <Button type="primary">{t('Back to home')}</Button>
                </Link>
            }
        />
    );
};

export default NotFound;
